export const UNIT = 8;
export const MIN_WIDTH_UNITS = 30;
export const DRAWER_WIDTH_UNITS = 30;
export const COLLAPSE_DRAWER_WIDTH_UNITS = 7;
//# sourceMappingURL=constants.js.map